import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=bf4b913c&scoped=true&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=bf4b913c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4b913c",
  null
  
)

export default component.exports